import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { FaGlobe, FaPhoneAlt } from "react-icons/fa"
import "./Navbar.css"
import logo from "../assets/logo.png"
import { useTranslation } from "react-i18next"

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isArabic = i18n.language.split("-")[0] === "ar";

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 400);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleLanguage = () => {
    const lang = i18n.language.split("-")[0];
    i18n.changeLanguage(lang === "ar" ? "en" : "ar");
  };

  const linksOrder = isArabic
    ? [
        { to: "/contact", label: t("navbar.contact") },
        { to: "/clients", label: t("navbar.clients") },
        { to: "/services", label: t("navbar.services") },
        { to: "/", label: t("navbar.home") },
      ]
    : [
        { to: "/", label: t("navbar.home") },
        { to: "/services", label: t("navbar.services") },
        { to: "/clients", label: t("navbar.clients") },
        { to: "/contact", label: t("navbar.contact") },
      ];

  return (
    <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      {isMobile ? (
        <>
          <div className="mobile-navbar">
            <Link to="/" className="logo_link">
              <img src={logo} className="logo mobile-logo" alt="Logo" />
            </Link>

            <button
              onClick={toggleLanguage}
              className="nav-icon-button lang-button-mobile"
            >
              <FaGlobe color="white" size={16} />
              <span className="nav-button-text">{isArabic ? "EN" : "AR"}</span>
            </button>

            <button
              className="hamburger-icon"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          {isMobileMenuOpen && (
            <div className="mobile-menu">
              {linksOrder.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:+966123456789"
                className="nav-icon-button call-button"
              >
                <FaPhoneAlt color="white" size={16} />
              </a>
            </div>
          )}
        </>
      ) : (
        <>
          <button onClick={toggleLanguage} className="nav-icon-button left">
            <FaGlobe color="white" size={16} />
            <span className="nav-button-text">{isArabic ? "EN" : "AR"}</span>
          </button>

          {linksOrder.slice(0, 2).map((link) => (
            <Link key={link.to} to={link.to}>
              {link.label}
            </Link>
          ))}

          <Link to="/" className="logo_link">
            <img src={logo} className="logo" alt="Logo Knowledge Impact" />
          </Link>

          {linksOrder.slice(2).map((link) => (
            <Link key={link.to} to={link.to}>
              {link.label}
            </Link>
          ))}

          <a href="tel:+966123456789" className="nav-icon-button right">
            <FaPhoneAlt color="white" size={16} />
          </a>
        </>
      )}
    </nav>
  )
}

export default Navbar